import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../atoms/modal/Modal';
import { getFlightNameAndLogoPath } from '../../utils/plain';
import { AIRLINES } from '../../constants';


const ModalConnectingFlights = ({ open, onClose, connectingFlights, selectedAirline }) => {

  const isJal = selectedAirline === AIRLINES.jal;

  return (
    <Modal
      open={open}
      onClose={onClose}
      className="connectingFlightsModal"
      bodyClassName="cautionModalBody"
      overlayClassName="cautionModalOverlay"
      customHeader={() => (
        <div className="connectingFlightsModalHeader">
          <div className="cautionModalHeaderTitle">乗継便情報</div>
          <div className="cautionModalClose" onClick={onClose}/>
        </div>
      )}
    >
      <div>
        {connectingFlights.map((f, i) => {
          const { flightName, logoPath } = getFlightNameAndLogoPath(f);
          const {
            departureTime,
            arrivalTime,
            departureAirportName,
            arrivalAirportName,
            airline,
            operationCarrier,
          } = f;

          return (
            <div key={i} className="connectingFlightsItem">
              <div className="connectingFlightsItemField">
                {logoPath && (
                  <img src={`/dp-air/img/logo/${logoPath}`} alt={airline} />
                )}
                {flightName}
                {operationCarrier && (
                  <React.Fragment>
                    <br/>
                    {operationCarrier}運航
                  </React.Fragment>
                )}
              </div>
              <div className="connectingFlightsItemField bold">
                <div className="planePlanTableAirportName">{departureAirportName}</div>
                <div className="planePlanTableFlightTime">{departureTime}</div>
              </div>
              <div className="connectingFlightsItemField bold">
                →
              </div>
              <div className="connectingFlightsItemField bold">
                <div className="planePlanTableAirportName">{arrivalAirportName}</div>
                <div className="planePlanTableFlightTime">{arrivalTime}</div>
              </div>
            </div>
          );
        })}
      </div>
      {isJal && (
        <div style={{ fontSize: 12, marginTop: 16 }}>
          【乗継便選択時のクラスＪ席ご注意】
          <ul>
            <li>・経由便の場合、全区間でクラスＪ席を予約できない場合があります。</li>
            <li>・クラスＪ設定機材で空席がある区間のみ、クラスＪ席でのご予約となります。</li>
            <li>・クラスＪ利用時の差額は、ご予約可能な区間分のみ適用し表示しております。</li>
          </ul>
        </div>
      )}
    </Modal>
  );
};

ModalConnectingFlights.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  connectingFlights: PropTypes.array.isRequired,
  selectedAirline: PropTypes.string.isRequired,
};

export default ModalConnectingFlights;
